// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"67534dfe","279":"ed3f33ee","314":"7c7b6c3b","410":"ed3f33ee","618":"a5d3e567","799":"ed3f33ee"}[chunkId] + ".chunk.css";
};